import { FC } from "react";
import { IInputField } from "cayo.ui";
import { IProxyAddressesGrid } from "@cayo/shared/api/types/schema";

type ProxyAddressesGridProps = IProxyAddressesGrid & IInputField;

const ProxyAddressesGrid: FC<ProxyAddressesGridProps> = () => null;

export default ProxyAddressesGrid;
